module.exports = __webpack_public_path__ + "img/15.ee05a117.jpg";